import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver/FileSaver';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-contable',
  templateUrl: './contable.component.html',
  styleUrls: ['./contable.component.css']
})
export class ContableComponent implements OnInit {

  codcliente:number;
  anio:number;
  periodo:string;
  idcategoria:number;
  categorias;

  balance;
  sumas;
  perdidas;
  actuaciones;
  otros;
  facturas;
  

  constructor(private activatedRoute:ActivatedRoute, private clientesPymesService:ClientesPymesService,
    private location:Location, private router:Router, private auth:AuthService) {
      this.activatedRoute.queryParams
    .subscribe(params=>{
      this.codcliente=params["idC"];
      this.anio=params["a"];
      
      if(this.auth.esClientePymes() && this.codcliente && this.codcliente!=this.auth.usuarioActivo.CLcodigo){
        this.router.navigate(['/home']);
        return false;
      }

      if(this.codcliente && this.anio && !this.idcategoria){
        this.cargarCategorias(this.codcliente, this.anio);
      }
    });
  }

  ngOnInit() {
  }

  cargarCategorias(codcliente, anio){
    this.clientesPymesService.cargarCategoriasContable(codcliente, anio)
    .subscribe(resp=>{
      this.categorias=resp;
      this.idcategoria=this.categorias[0]["DLid"];

      if(this.idcategoria){
        
        this.cargarCategoriaActual(this.idcategoria);
        this.cargarTodosDocumentos();
      }
      
    });
  }
  
  cargarTodosDocumentos(){
    this.cargarDocumentos('BA');
    this.cargarDocumentos('SU');
    this.cargarDocumentos('PG');
    this.cargarDocumentos('AC');
    this.cargarDocumentos('OT');
    this.cargarDocumentos('FA');
  }
  
  cargarDocumentos(codtipodoc){
    
    this.clientesPymesService.cargarDocumentosContable(this.codcliente, this.anio, codtipodoc)
    .subscribe(resp=>{
      
      switch(codtipodoc){
        case 'BA':
          this.balance=resp;
        break;
        case 'SU':
          this.sumas=resp;
        break;
        case 'PG':
          this.perdidas=resp;
        break;
        case 'AC':
          this.actuaciones=resp;
        break;
        case 'OT':
          this.otros=resp;
        break;
        case 'FA':
          this.facturas=resp;
        break;
      }
      
    });
  }

  cargarMes(codCategoria){
    this.clientesPymesService.cargarMes(codCategoria)
    .subscribe(resp=>{
      this.periodo=resp["DLcategoria"];
      this.anio=resp["DLanio"];
    });
  }

  cargarCategoriaActual(codCategoria){
    this.clientesPymesService.cargarCategoriaActual(codCategoria)
    .subscribe(resp=>{
      if(resp["err"]==true){
        this.router.navigate(["/home"]);
        return false;
      }
    });
  }

  volver(){
    this.location.back();
  }

  descargarDoc(ruta:string){
    
    let rutaspliteada=ruta.split("/");
    let nombrearchivo=rutaspliteada[rutaspliteada.length-1];
    
    //window.location.href='https://app.solucionlegal.es/API/index.php/auth/descargar';
    this.clientesPymesService.descargarDoc(ruta)
    .subscribe(data=>saveAs(data, nombrearchivo)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
    //data=>window.open(window.URL.createObjectURL(data))
  }

  borrarDoc(codigoDoc, codtipodoc){
    if(confirm("¿Desea borrar el documento seleccionado?")){
      this.clientesPymesService.borrarDoc(codigoDoc)
      .subscribe(resp=>{
        this.cargarDocumentos(codtipodoc);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contable/contable.component.ts